// Углы и геометрия колеса

// Привести угол к диапазону [0, 360)
export const normalizeAngleDeg = (deg: number) => ((deg % 360) + 360) % 360;

// Кратчайшая ПОЛОЖИТЕЛЬНАЯ дельта-поворота current → target (в градусах)
export const shortestPositiveDelta = (
  currentDeg: number,
  targetDeg: number,
) => {
  const raw = targetDeg - currentDeg;
  return raw >= 0 ? raw : raw + 360;
};

// По отрисовке: сектор 0 находится сверху при angle=0, поэтому по умолчанию topOffsetDeg=0.
export function computeTargetAngleFromIndex(options: {
  index: number;
  degreesPerSector: number;
  topOffsetDeg?: number; // 0° — вверх
  clockwise?: boolean; // true — индексация по часовой
}) {
  const {
    index,
    degreesPerSector,
    topOffsetDeg = 0,
    clockwise = true,
  } = options;

  const signedIndex = clockwise ? index : -index;
  // Важно: чтобы нужный сектор оказался сверху, итоговый угол диска:
  // topOffsetDeg - signedIndex * degreesPerSector
  return normalizeAngleDeg(topOffsetDeg - signedIndex * degreesPerSector);
}

// Найти индекс сектора по id, вернуть -1 если не найден
export function findSectionIndexById<T extends { id: string }>(
  sections: T[],
  id: string,
) {
  return sections.findIndex((s) => s.id === id);
}

// Считать секцию “выигрышной” если есть rewardId (не пустой)
export function isWinningSection<T extends { rewardId?: string | null }>(
  section: T,
) {
  return Boolean(section && section.rewardId);
}
